module.exports = __webpack_public_path__ + "img/movies_pic.144f7da3.png";